import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/delta2/h5/');
export default function GrowingEco() {
    const { useState, useLang, useRouter } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const [swiper, setSwiper] = useState(null);
    const { locale } = useRouter();
    const handleReachEnd = () => {
        swiper.params.autoplay.reverseDirection = true;
    };

    const handleReachBeginning = () => {
        swiper.params.autoplay.reverseDirection = false;
    };
    const bannerMap: Record<string, string[]> = {
        us: ['banner4', 'banner6', 'banner5', 'banner7'],
        ph: ['banner4', 'banner6', 'banner5'],
        kr: ['banner4_kr', 'banner6', 'banner5_kr', 'banner7'],
    };
    const bannerObj = bannerMap[locale] || bannerMap.us;
    const bannerList = [
        { key: 1, img: bannerObj[0] },
        { key: 2, img: bannerObj[1] },
        { key: 3, img: bannerObj[2] },
        locale !== 'ph' && { key: 4, img: bannerObj[3] },
    ].filter(Boolean);

    return (
        <div className={`${css.GrowingEco} GrowingEco GtmModuleData-section`} data-section-id={css.GrowingEco} data-section-title={t('delta2.aniL_msg1')}>
            <div className="g-box">
                <div className="g-title">{t('delta2.aniL_msg1')}</div>
                <div className="g-swiper">
                    <Swiper
                        modules={[Autoplay]}
                        pagination={{
                            clickable: true,
                        }}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        preloadImages={false}
                        lazy={true}
                        autoplay={{
                            delay: 4000,
                            disableOnInteraction: false,
                        }}
                        spaceBetween={26}
                        centeredSlides={true}
                        grabCursor={true}
                        onSwiper={(swiper: any) => setSwiper(swiper)}
                        onReachEnd={handleReachEnd}
                        onReachBeginning={handleReachBeginning}
                    >
                        {bannerList?.map((item: any, k: number) => (
                            <SwiperSlide key={k}>
                                <EFPic name={[`${item.img}.webp`, `${item.img}.jpg`]} />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className="g-des">{t('delta2.aniL_msg2')}</div>
            </div>
        </div>
    );
}
